import { t } from 'i18next';
import { type Id, toast, type ToastOptions } from 'react-toastify';

const toastMeta: { id: null | Id } = { id: null };

export function errorToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.error(t(msg), options);
}

export function successToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.success(t(msg), options);
}

export function infoToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast(t(msg), options);
}

export function warningToast(
  msg: string,
  shouldDismissAllToast: boolean = true,
  options?: ToastOptions | undefined
) {
  if (shouldDismissAllToast) {
    dismissAllToast();
  }
  toastMeta.id = toast.warning(t(msg), options);
}

function dismissAllToast() {
  if (toastMeta.id) {
    toast.clearWaitingQueue();
    toast.dismiss(toastMeta.id);
  }
}
